if (typeof AddOnsSingleProducts !== 'function') {
    class AddOnsSingleProducts extends HTMLElement {
        constructor() {
            super();

            this.buttonHandleTooltip = this.querySelectorAll('[data-button-handle-tooltip]');
            this.buttonDismiss = this.querySelectorAll('[data-modal-dismiss]');
            this.optionButtons = this.querySelectorAll('[data-addons-product]');

            if (this.buttonHandleTooltip) {
                this.buttonHandleTooltip.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const target = button.getAttribute('data-tooltip-target');
                        this.querySelector(`#${target}`).classList.add('show');
                    })
                })
            }

            if (this.buttonDismiss) {
                this.buttonDismiss.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const target = button.getAttribute('data-tooltip-target');
                        this.querySelector(`#${target}`).classList.remove('show');
                    })
                })
            }

            if (this.optionButtons) {
                this.optionButtons.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (!button.getAttribute("data-available") || button.getAttribute("data-available") == "true") {
                            const productIde = button.getAttribute('data-value');
                            const datafor = button.getAttribute('data-for');
                            let dataP = button.getAttribute("data-seek");
                            if (!button.classList.contains('active')) {

                                this.querySelectorAll('[data-addons-product]').forEach(ele => {
                                    ele.classList.remove('active');
                                });
                                const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                                allInputs.forEach(ele => {
                                    ele.remove();
                                })
                                button.classList.add('active');
                                if (dataP === null) {
                                    dataP = 0;
                                }
                                this.handleAddAddons(productIde, datafor, dataP);
                            } else {
                                const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                                allInputs.forEach(ele => {
                                    ele.remove();
                                })
                                console.log(productIde);
                                button.classList.remove('active');
                            }
                        }
                    })
                })
            }

        }
        handleAddAddons(ide, datafor, dataP) {
            if (ide) {
                //Sticky form
                const element = document.createElement('input');
                element.value = ide;
                element.type = 'hidden';
                element.name = 'id';
                element.setAttribute('data-for', datafor);
                element.setAttribute("data-seek", dataP)
                element.classList.add = 'addon_input';
                element.setAttribute('data-quantity', 1);
                const formContent = document.getElementById('bulk-add-to-cart');
                formContent.append(element);

                const dataKit = document.querySelector('input[data-for="kit-addon"]');

                if(dataKit) {
                    dataKit.remove();
                    document.querySelector('[data-add-to-car]').classList.remove('active');
                    document.querySelector('[data-button-remove]').classList.remove('active');
                }
            } else {
                document.querySelector(`input[data-for="${datafor}"]`)?.remove();
            }
            this.getFinalPrice();
        }

        getFinalPrice() {
            const elementsForm = document.querySelectorAll('input[data-seek]');
            let total = 0;
            elementsForm.forEach((e) => {
                if (e.getAttribute("data-seek") && e.getAttribute("data-seek") !== null) {
                    total += Number(e.getAttribute("data-seek"));
                }
            })
            const formattedNumber = (total / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
            document.querySelectorAll('.total_buy_button').forEach((button) => {
                button.innerHTML = formattedNumber;
            });
            document.getElementById('total_buy').innerHTML = formattedNumber;

        }


    }

    if (typeof customElements.get('addon-single-product') == 'undefined') {
        customElements.define('addon-single-product', AddOnsSingleProducts);
    }
}